import { render, staticRenderFns } from "./ConsultationNotes.vue?vue&type=template&id=46a18d6a&lang=pug"
import script from "./ConsultationNotes.vue?vue&type=script&lang=js"
export * from "./ConsultationNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NorxSituations: require('/home/docker/code/frontend/components/NorxSituations.vue').default,CsnpConditions: require('/home/docker/code/frontend/components/CsnpConditions.vue').default})
